import React, { useState } from "react";
import {
  TrendingDown,
  HeartHandshake,
  Building2,
  BadgeCheck,
  ClipboardList,
  FileSearch,
  Users,
  CalendarCheck,
  KeyRound,
  Check,
  X,
  Layers,
  Target,
  Handshake,
  ShieldCheck,
  Award,
  Briefcase,
  Home,
  Building,
  Users2,
  BarChart3,
  Sparkles,
} from "lucide-react";
import CtaSection, { CtaButton } from "../components/common/CtaSection";
import LeadCaptureModal from "../components/common/LeadCaptureModal";
import { LEAD_CHANNELS } from "../constants/data";
// import whygb from "../assets/logos/whygb.png";
import heroImg2 from "../assets/Image4.png";

const GOLD = "#50C878";
const NAVY = "#013220";

// ─── WHY GROUP BUY ────────────────────────────────────────────
// Buyer-facing "Why GroupBuy?" page. Content sourced from the
// GroupBuy Flats company document — the buyer community model,
// the four benefit pillars, the 5-step buyer process, and the
// "GroupBuy is / is not" positioning.
// ─────────────────────────────────────────────────────────────

const BENEFITS = [
  {
    icon: TrendingDown,
    title: "Better Pricing",
    body: "Group buying enables buyers to access exclusive developer pricing and special offers that are typically unavailable through conventional sales channels.",
  },
  {
    icon: HeartHandshake,
    title: "Strong Negotiation Power",
    body: "When many buyers commit together, developers can offer better deals and bigger savings than any individual could secure alone.",
  },
  {
    icon: Building2,
    title: "Direct Booking with the Developer",
    body: "All purchases are completed directly with the developer, ensuring complete transparency and security at every step.",
  },
  {
    icon: BadgeCheck,
    title: "Verified Projects",
    body: "Only RERA-approved and developer-authorised projects are introduced to the GroupBuy community.",
  },
];

const STEPS = [
  {
    icon: ClipboardList,
    step: "Step 1",
    title: "Register Interest",
    body: "Buyers submit their interest to join the GroupBuy opportunity.",
  },
  {
    icon: FileSearch,
    step: "Step 2",
    title: "Project Selection",
    body: "You receive complete details about the selected project including location, pricing, floor plans, and developer information.",
  },
  {
    icon: Users,
    step: "Step 3",
    title: "Join the Buyer Group",
    body: "Interested buyers become part of the buyer group for the project.",
  },
  {
    icon: CalendarCheck,
    step: "Step 4",
    title: "Group Closure Event",
    body: "All buyers meet the developer during a coordinated closure session where special group pricing is announced and negotiated.",
  },
  {
    icon: KeyRound,
    step: "Step 5",
    title: "Book Your Flat",
    body: "Each buyer books their selected unit directly with the developer through the standard booking process.",
  },
];

const LOVE_POINTS = [
  "Transparent booking process",
  "Access to special pricing",
  "Buy directly from developer",
  "Transparent negotiation",
];

const IS_POINTS = [
  "A closed-group sales strategy",
  "Designed exclusively for developers and bulk buyers",
  "Focused on structured fund generation through property sales",
];

const IS_NOT_POINTS = [
  "Not a property listing portal",
  "Not a traditional channel partner",
  "Not focused on individual retail sales",
];

// ─── NEW CONTENT FROM DOCUMENT ──────────────────────────────

const ABOUT_US_POINTS = [
  "Better pricing than market",
  "Faster inventory liquidation for developers",
  "Optimized Investment Opportunity",
];

const VISION_MISSION = {
  vision: "To become India's most trusted and scalable platform for unified real estate investments by delivering value, transparency, and long-term growth.",
  mission: [
    "Empower buyers with Big Savings through collective negotiation",
    "Empower developers to accelerate inventory absorption and improve sales efficiency",
    "Create a Win-Win Opportunities for all Stakeholders",
    "Bring structure, transparency, and trust into bulk real estate transactions",
  ],
};

const WHY_CHOOSE = [
  "Proven expertise in high-value real estate transactions",
  "Portfolio of projects worth ₹1000+ Crores under management",
  "Strong Network of Developers & Investors",
  "Transparent, ethical, and professional approach",
  "Focus on long-term relationships",
];

const KEY_STRENGTHS = [
  "Expert Deal Planning and Execution",
  "Deep Market Intelligence and Pricing Insights",
  "Dedicated Property Advisory Team",
  "Strong negotiation expertise",
  "End-to-end Support",
];

const TARGET_MARKETS = [
  { icon: Home, label: "Residential Apartments" },
  { icon: Building, label: "Villas & Gated Communities" },
  { icon: BarChart3, label: "Investor-driven Opportunities" },
];

const TEAM_AREAS = [
  "Developer Relations",
  "Investment Advisory",
  "Sales & Marketing Strategy",
  "Deal Management",
];

const VALUE_PROPS = [
  "Buy as a group. Save More. Invest Smarter.",
  "Maximum value for every stakeholder",
];

const CONCEPT_DESCRIPTION =
  "At the core of our operations is the Power of Group Buying, where multiple buyers come together to purchase properties in bulk. This enables Bulk Deal Negotiation Exclusive Pricing Advantages";

const HOW_IT_WORKS = [
  {
    title: "Project Identification",
    desc: "We carefully select and onboard high-potential, premium projects with strong fundamentals.",
  },
  {
    title: "Demand Aggregation",
    desc: "We bring together serious buyers and investors interested in the same opportunity.",
  },
  {
    title: "Negotiation & Structuring",
    desc: "Our team negotiates bulk pricing and favourable commercial terms with developers.",
  },
  {
    title: "Deal Closure",
    desc: "Final deal closure, ensuring a smooth and transparent buying experience.",
  },
];

export default function WhyGroupBuyPage() {
  const [showModal, setShowModal] = useState(false);

  return (
    <div style={{ background: "#F2F8F3", color: NAVY, minHeight: "100vh", paddingTop: "68px" }}>
      {/* Hero */}
      <div
        style={{
          position: "relative",
          padding: 0,
          textAlign: "left",
          backgroundImage: `url(${heroImg2})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          borderBottom: "1px solid rgba(80,200,120,0.2)",
          overflow: "hidden",
          height: "80vh",
          minHeight: "500px",
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "flex-start",
        }}
      >
        <div
          style={{
            position: "absolute",
            inset: 0,
            background:
              "linear-gradient(90deg, rgba(15,30,50,0.85) 0%, rgba(15,30,50,0.6) 40%, rgba(15,30,50,0.2) 70%, rgba(15,30,50,0) 100%)",
            zIndex: 1,
          }}
        />
        <div style={{ position: "absolute", bottom: "60px", left: "60px", zIndex: 2, maxWidth: "660px", padding: "0 24px" }}>
          <span
            style={{
              fontFamily: "'Inter', sans-serif",
              fontSize: "0.6rem",
              color: GOLD,
              letterSpacing: "0.2em",
              textTransform: "uppercase",
              textShadow: "0 1px 4px rgba(0,0,0,0.45)",
              display: "block",
              marginBottom: "6px",
            }}
          >
            Buy Smart. Pay Less.
          </span>
          <h1
            style={{
              fontFamily: "'Cormorant Garamond', serif",
              fontSize: "clamp(2rem, 4vw, 3.2rem)",
              fontWeight: 600,
              margin: "0 0 12px",
              color: "#FFFFFF",
              textShadow: "0 2px 14px rgba(0,0,0,0.5)",
              lineHeight: 1.2,
            }}
          >
            Why GroupBuy?
          </h1>
          <p
            style={{
              fontFamily: "'Inter', sans-serif",
              fontSize: "clamp(0.95rem, 1.3vw, 1.1rem)",
              color: "rgba(255,255,255,0.92)",
              lineHeight: 1.7,
              maxWidth: "550px",
              margin: "0 0 24px",
              textShadow: "0 1px 8px rgba(0,0,0,0.5)",
            }}
          >
            Join GroupBuy and unlock special pricing on premium flats. When buyers come together as a group,
            they gain stronger negotiating power — and buy directly from the developer.
          </p>
          <CtaButton label="Join the Next Group" onClick={() => setShowModal(true)} />
        </div>
      </div>

      {/* What is GroupBuy */}
      <section style={{ maxWidth: "900px", margin: "0 auto", padding: "60px 24px 40px" }}>
        <div
          style={{
            background: "linear-gradient(135deg, #FFFFFF 0%, #F7FBF8 100%)",
            border: "1px solid rgba(80,200,120,0.18)",
            borderRadius: "14px",
            padding: "40px 44px",
          }}
        >
          <h2 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "2rem", fontWeight: 600, margin: "0 0 16px" }}>
            What is GroupBuy?
          </h2>
          <p style={{ fontFamily: "'Inter', sans-serif", fontSize: "1.02rem", color: "rgba(1,50,32,0.78)", lineHeight: 1.9, margin: "0 0 18px" }}>
            GroupBuy is a buyer community purchasing model where multiple investors join together to negotiate
            better deals on RERA-approved real estate projects. Instead of purchasing a flat individually,
            buyers participate in a structured group purchase event that unlocks special prices.
          </p>
          <p style={{ fontFamily: "'Inter', sans-serif", fontSize: "1.02rem", color: "rgba(1,50,32,0.78)", lineHeight: 1.9, margin: 0 }}>
            Through GroupBuy, you get the benefits of bulk purchasing power while still owning your flat
            individually. GroupBuy Flats allows you to purchase property at special group pricing directly from
            the developer.
          </p>
        </div>
      </section>

      {/* ─── NEW: About Us Section ─────────────────────────────── */}
      <section style={{ maxWidth: "1100px", margin: "0 auto", padding: "20px 24px 30px" }}>
        <div
          style={{
            background: "linear-gradient(135deg, #FFFFFF 0%, #F7FBF8 100%)",
            border: "1px solid rgba(80,200,120,0.18)",
            borderRadius: "14px",
            padding: "40px 44px",
          }}
        >
          <h2 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "2rem", fontWeight: 600, margin: "0 0 12px" }}>
            About GroupBuy Flats
          </h2>
          <p style={{ fontFamily: "'Inter', sans-serif", fontSize: "1.02rem", color: "rgba(1,50,32,0.78)", lineHeight: 1.9, margin: "0 0 20px" }}>
            GroupBuy Flats is a next-gen real estate company specializing in bulk property transactions and strategic investment.
            We act as a bridge between real estate developers and Buyers/Investors by aggregating demand and structuring high-value group deals.
          </p>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: "14px" }}>
            {ABOUT_US_POINTS.map((point) => (
              <div key={point} style={{ display: "flex", alignItems: "center", gap: "10px", background: "rgba(80,200,120,0.06)", padding: "12px 16px", borderRadius: "10px" }}>
                <Sparkles size={18} color={GOLD} />
                <span style={{ fontFamily: "'Inter', sans-serif", fontSize: "0.95rem", color: "rgba(1,50,32,0.8)" }}>{point}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ─── NEW: Vision & Mission ────────────────────────────── */}
      <section style={{ maxWidth: "1100px", margin: "0 auto", padding: "10px 24px 30px" }}>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", gap: "24px" }}>
          <div
            style={{
              background: "linear-gradient(135deg, #FFFFFF 0%, #F7FBF8 100%)",
              border: "1px solid rgba(80,200,120,0.18)",
              borderRadius: "14px",
              padding: "32px 30px",
              borderLeft: `4px solid ${GOLD}`,
            }}
          >
            <h3 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "1.5rem", fontWeight: 600, margin: "0 0 12px", display: "flex", alignItems: "center", gap: "10px" }}>
              <Target size={24} color={GOLD} /> Vision
            </h3>
            <p style={{ fontFamily: "'Inter', sans-serif", fontSize: "1rem", color: "rgba(1,50,32,0.78)", lineHeight: 1.8, margin: 0 }}>
              {VISION_MISSION.vision}
            </p>
          </div>
          <div
            style={{
              background: "linear-gradient(135deg, #FFFFFF 0%, #F7FBF8 100%)",
              border: "1px solid rgba(80,200,120,0.18)",
              borderRadius: "14px",
              padding: "32px 30px",
              borderLeft: `4px solid ${GOLD}`,
            }}
          >
            <h3 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "1.5rem", fontWeight: 600, margin: "0 0 12px", display: "flex", alignItems: "center", gap: "10px" }}>
              <Award size={24} color={GOLD} /> Mission
            </h3>
            <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
              {VISION_MISSION.mission.map((item) => (
                <li key={item} style={{ fontFamily: "'Inter', sans-serif", fontSize: "0.97rem", color: "rgba(1,50,32,0.78)", lineHeight: 1.7, padding: "4px 0", display: "flex", gap: "10px" }}>
                  <Check size={16} color={GOLD} style={{ marginTop: "4px", flexShrink: 0 }} /> {item}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      {/* ─── NEW: The Concept ──────────────────────────────────── */}
      <section style={{ maxWidth: "900px", margin: "0 auto", padding: "10px 24px 30px" }}>
        <div
          style={{
            background: "linear-gradient(135deg, #FFFFFF 0%, #F7FBF8 100%)",
            border: "1px solid rgba(80,200,120,0.18)",
            borderRadius: "14px",
            padding: "32px 36px",
            textAlign: "center",
          }}
        >
          <h2 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "1.8rem", fontWeight: 600, margin: "0 0 12px" }}>
            The Concept
          </h2>
          <p style={{ fontFamily: "'Inter', sans-serif", fontSize: "1.05rem", color: "rgba(1,50,32,0.78)", lineHeight: 1.8, margin: 0 }}>
            {CONCEPT_DESCRIPTION}
          </p>
        </div>
      </section>

      {/* ─── NEW: How It Works (Company Process) ────────────── */}
      <section style={{ maxWidth: "1000px", margin: "0 auto", padding: "20px 24px 30px" }}>
        <div style={{ textAlign: "center", marginBottom: "30px" }}>
          <h2 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "2rem", fontWeight: 600, margin: 0 }}>
            How GroupBuy Works
          </h2>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: "20px" }}>
          {HOW_IT_WORKS.map((item, idx) => (
            <div
              key={idx}
              style={{
                background: "linear-gradient(135deg, #FFFFFF 0%, #F7FBF8 100%)",
                border: "1px solid rgba(80,200,120,0.18)",
                borderRadius: "14px",
                padding: "24px 22px",
                textAlign: "center",
              }}
            >
              <div
                style={{
                  width: "48px",
                  height: "48px",
                  borderRadius: "50%",
                  background: "rgba(80,200,120,0.12)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto 14px",
                  fontSize: "1.2rem",
                  fontWeight: 700,
                  color: GOLD,
                }}
              >
                {idx + 1}
              </div>
              <h4 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "1.2rem", fontWeight: 600, margin: "0 0 8px" }}>
                {item.title}
              </h4>
              <p style={{ fontFamily: "'Inter', sans-serif", fontSize: "0.92rem", color: "rgba(1,50,32,0.7)", lineHeight: 1.6, margin: 0 }}>
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </section>

      {/* Benefit pillars (existing) */}
      <section style={{ maxWidth: "1100px", margin: "0 auto", padding: "20px 24px 50px" }}>
        <div style={{ textAlign: "center", marginBottom: "36px" }}>
          <h2 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "2rem", fontWeight: 600, margin: 0 }}>
            The GroupBuy Advantage
          </h2>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))", gap: "22px" }}>
          {BENEFITS.map(({ icon: Icon, title, body }) => (
            <div
              key={title}
              style={{
                background: "linear-gradient(135deg, #FFFFFF 0%, #F7FBF8 100%)",
                border: "1px solid rgba(80,200,120,0.18)",
                borderRadius: "14px",
                padding: "28px",
              }}
            >
              <div
                style={{
                  width: "48px",
                  height: "48px",
                  borderRadius: "10px",
                  background: "rgba(80,200,120,0.12)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: "16px",
                }}
              >
                <Icon size={24} color={GOLD} />
              </div>
              <h3 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "1.3rem", fontWeight: 600, margin: "0 0 10px" }}>
                {title}
              </h3>
              <p style={{ fontFamily: "'Inter', sans-serif", fontSize: "0.95rem", color: "rgba(1,50,32,0.72)", lineHeight: 1.7, margin: 0 }}>
                {body}
              </p>
            </div>
          ))}
        </div>
      </section>

      {/* How the Buyer Process Works (existing) */}
      <section
        style={{
          background: "#F7FBF8",
          borderTop: "1px solid rgba(80,200,120,0.12)",
          borderBottom: "1px solid rgba(80,200,120,0.12)",
          padding: "60px 24px",
        }}
      >
        <div style={{ maxWidth: "1000px", margin: "0 auto" }}>
          <div style={{ textAlign: "center", marginBottom: "40px" }}>
            <h2 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "2rem", fontWeight: 600, margin: 0 }}>
              How the Buyer Process Works
            </h2>
          </div>
          <div style={{ display: "grid", gap: "16px" }}>
            {STEPS.map(({ icon: Icon, step, title, body }) => (
              <div
                key={step}
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "20px",
                  background: "linear-gradient(135deg, #FFFFFF 0%, #F7FBF8 100%)",
                  border: "1px solid rgba(80,200,120,0.18)",
                  borderRadius: "14px",
                  padding: "24px 28px",
                }}
              >
                <div
                  style={{
                    width: "52px",
                    height: "52px",
                    borderRadius: "12px",
                    background: "rgba(80,200,120,0.12)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  <Icon size={24} color={GOLD} />
                </div>
                <div>
                  <span style={{ fontFamily: "'Inter', sans-serif", fontSize: "0.72rem", color: GOLD, letterSpacing: "0.14em", textTransform: "uppercase", fontWeight: 600 }}>
                    {step}
                  </span>
                  <h3 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "1.35rem", fontWeight: 600, margin: "4px 0 8px" }}>
                    {title}
                  </h3>
                  <p style={{ fontFamily: "'Inter', sans-serif", fontSize: "0.97rem", color: "rgba(1,50,32,0.74)", lineHeight: 1.7, margin: 0 }}>
                    {body}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ─── NEW: Why Choose GroupBuy Flats ──────────────────── */}
      <section style={{ maxWidth: "1000px", margin: "0 auto", padding: "50px 24px 30px" }}>
        <div style={{ textAlign: "center", marginBottom: "32px" }}>
          <h2 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "2rem", fontWeight: 600, margin: 0 }}>
            Why Choose GroupBuy Flats
          </h2>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))", gap: "16px" }}>
          {WHY_CHOOSE.map((item) => (
            <div
              key={item}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "12px",
                background: "white",
                padding: "16px 20px",
                borderRadius: "12px",
                border: "1px solid rgba(80,200,120,0.12)",
              }}
            >
              <Check size={18} color={GOLD} />
              <span style={{ fontFamily: "'Inter', sans-serif", fontSize: "0.95rem", color: "rgba(1,50,32,0.8)" }}>{item}</span>
            </div>
          ))}
        </div>
      </section>

      {/* ─── NEW: Key Strengths ────────────────────────────────── */}
      <section style={{ maxWidth: "1000px", margin: "0 auto", padding: "10px 24px 30px" }}>
        <div style={{ textAlign: "center", marginBottom: "32px" }}>
          <h2 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "2rem", fontWeight: 600, margin: 0 }}>
            Key Strengths
          </h2>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: "16px" }}>
          {KEY_STRENGTHS.map((item) => (
            <div
              key={item}
              style={{
                background: "linear-gradient(135deg, #FFFFFF 0%, #F7FBF8 100%)",
                border: "1px solid rgba(80,200,120,0.15)",
                borderRadius: "12px",
                padding: "20px 18px",
                textAlign: "center",
              }}
            >
              <ShieldCheck size={24} color={GOLD} style={{ marginBottom: "8px" }} />
              <span style={{ fontFamily: "'Inter', sans-serif", fontSize: "0.95rem", color: "rgba(1,50,32,0.8)", display: "block" }}>
                {item}
              </span>
            </div>
          ))}
        </div>
      </section>

      {/* ─── NEW: Target Markets ────────────────────────────────── */}
      <section style={{ maxWidth: "900px", margin: "0 auto", padding: "10px 24px 30px" }}>
        <div
          style={{
            background: "linear-gradient(135deg, #013220 0%, #024A30 100%)",
            borderRadius: "16px",
            padding: "40px 36px",
            textAlign: "center",
          }}
        >
          <h2 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "1.9rem", fontWeight: 600, margin: "0 0 24px", color: "#FFFFFF" }}>
            Target Markets
          </h2>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))", gap: "20px" }}>
            {TARGET_MARKETS.map(({ icon: Icon, label }) => (
              <div key={label} style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "8px" }}>
                <div style={{ width: "56px", height: "56px", borderRadius: "50%", background: "rgba(80,200,120,0.15)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <Icon size={28} color={GOLD} />
                </div>
                <span style={{ fontFamily: "'Inter', sans-serif", fontSize: "1rem", color: "rgba(255,255,255,0.9)" }}>{label}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ─── NEW: Our Team ────────────────────────────────────── */}
      <section style={{ maxWidth: "900px", margin: "0 auto", padding: "20px 24px 30px" }}>
        <div
          style={{
            background: "linear-gradient(135deg, #FFFFFF 0%, #F7FBF8 100%)",
            border: "1px solid rgba(80,200,120,0.18)",
            borderRadius: "14px",
            padding: "36px 40px",
            textAlign: "center",
          }}
        >
          <h2 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "2rem", fontWeight: 600, margin: "0 0 12px" }}>
            Our Team
          </h2>
          <p style={{ fontFamily: "'Inter', sans-serif", fontSize: "1.02rem", color: "rgba(1,50,32,0.78)", lineHeight: 1.7, margin: "0 0 20px" }}>
            GroupBuy Flats is led by a team of experienced professionals with expertise in:
          </p>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))", gap: "12px" }}>
            {TEAM_AREAS.map((area) => (
              <div
                key={area}
                style={{
                  background: "rgba(80,200,120,0.08)",
                  padding: "12px 16px",
                  borderRadius: "10px",
                  fontFamily: "'Inter', sans-serif",
                  fontSize: "0.95rem",
                  color: "rgba(1,50,32,0.8)",
                  fontWeight: 500,
                }}
              >
                {area}
              </div>
            ))}
          </div>
          <p style={{ fontFamily: "'Inter', sans-serif", fontSize: "0.97rem", color: "rgba(1,50,32,0.7)", lineHeight: 1.6, margin: "20px 0 0" }}>
            Our leadership ensures every deal is executed with precision, professionalism, and integrity.
          </p>
        </div>
      </section>

      {/* ─── NEW: Value Proposition ───────────────────────────── */}
      <section style={{ maxWidth: "800px", margin: "0 auto", padding: "10px 24px 30px" }}>
        <div
          style={{
            background: "linear-gradient(135deg, #FFFFFF 0%, #F7FBF8 100%)",
            border: `2px solid ${GOLD}`,
            borderRadius: "14px",
            padding: "32px 36px",
            textAlign: "center",
          }}
        >
          <h2 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "1.8rem", fontWeight: 600, margin: "0 0 8px", color: NAVY }}>
            Value Proposition
          </h2>
          <p style={{ fontFamily: "'Inter', sans-serif", fontSize: "1.2rem", color: GOLD, fontWeight: 600, margin: "0 0 8px" }}>
            "{VALUE_PROPS[0]}"
          </p>
          <p style={{ fontFamily: "'Inter', sans-serif", fontSize: "1rem", color: "rgba(1,50,32,0.7)", margin: 0 }}>
            {VALUE_PROPS[1]}
          </p>
        </div>
      </section>

      {/* Why Buyers Love GroupBuy (existing) */}
      <section style={{ maxWidth: "900px", margin: "0 auto", padding: "30px 24px 30px" }}>
        <div
          style={{
            background: "linear-gradient(135deg, #013220 0%, #024A30 100%)",
            borderRadius: "16px",
            padding: "44px",
          }}
        >
          <h2 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "1.9rem", fontWeight: 600, margin: "0 0 24px", color: "#FFFFFF", textAlign: "center" }}>
            Why Buyers Love GroupBuy
          </h2>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))", gap: "16px" }}>
            {LOVE_POINTS.map((point) => (
              <div key={point} style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                <div
                  style={{
                    width: "26px",
                    height: "26px",
                    borderRadius: "50%",
                    background: "rgba(80,200,120,0.2)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  <Check size={15} color={GOLD} />
                </div>
                <span style={{ fontFamily: "'Inter', sans-serif", fontSize: "1rem", color: "rgba(255,255,255,0.9)" }}>
                  {point}
                </span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* GroupBuy IS / IS NOT (existing) */}
      <section style={{ maxWidth: "1000px", margin: "0 auto", padding: "30px 24px 60px" }}>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", gap: "22px" }}>
          {/* IS */}
          <div
            style={{
              background: "linear-gradient(135deg, #FFFFFF 0%, #F7FBF8 100%)",
              border: "1px solid rgba(80,200,120,0.25)",
              borderRadius: "14px",
              padding: "32px 30px",
            }}
          >
            <h3 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "1.5rem", fontWeight: 600, margin: "0 0 18px" }}>
              GroupBuy <span style={{ color: GOLD }}>IS</span>
            </h3>
            <div style={{ display: "grid", gap: "14px" }}>
              {IS_POINTS.map((point) => (
                <div key={point} style={{ display: "flex", alignItems: "flex-start", gap: "12px" }}>
                  <Check size={18} color={GOLD} style={{ marginTop: "3px", flexShrink: 0 }} />
                  <span style={{ fontFamily: "'Inter', sans-serif", fontSize: "0.97rem", color: "rgba(1,50,32,0.78)", lineHeight: 1.6 }}>
                    {point}
                  </span>
                </div>
              ))}
            </div>
          </div>

          {/* IS NOT */}
          <div
            style={{
              background: "linear-gradient(135deg, #FFFFFF 0%, #F7FBF8 100%)",
              border: "1px solid rgba(192,32,31,0.18)",
              borderRadius: "14px",
              padding: "32px 30px",
            }}
          >
            <h3 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "1.5rem", fontWeight: 600, margin: "0 0 18px" }}>
              GroupBuy is <span style={{ color: "#C0201F" }}>NOT</span>
            </h3>
            <div style={{ display: "grid", gap: "14px" }}>
              {IS_NOT_POINTS.map((point) => (
                <div key={point} style={{ display: "flex", alignItems: "flex-start", gap: "12px" }}>
                  <X size={18} color="#C0201F" style={{ marginTop: "3px", flexShrink: 0 }} />
                  <span style={{ fontFamily: "'Inter', sans-serif", fontSize: "0.97rem", color: "rgba(1,50,32,0.78)", lineHeight: 1.6 }}>
                    {point}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <CtaSection
        eyebrow="Strength in numbers"
        title="Ready to negotiate from strength?"
        subtitle="Register today and we'll add you to the next group buy that matches your needs."
        primaryLabel="Register Your Interest"
        onPrimaryClick={() => setShowModal(true)}
      />

      <LeadCaptureModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        channel={LEAD_CHANNELS.WEB}
        prefillMessage="Enquiry from the Why GroupBuy page"
      />
    </div>
  );
}